import { useState } from "react";
import Input from "../../Input";
import { FiUser, FiPackage, FiDownload } from "react-icons/fi";

function CompetitionUserIndexList({ users = [] }) {
    const [search, setSearch] = useState("");

    const user = users[0];

    const filteredProducts = users.filter((item) => {
        const searchValue = search.toLowerCase();

        return (
            item.pn?.toLowerCase().includes(searchValue) ||
            item.Name?.toLowerCase().includes(searchValue)
        );
    });

    const exportToCSV = () => {
        if (!users.length) return;

        const headers = ["Indeks", "Nazwa produktu"];

        const rows = users.map((product) => [
            product.pn || "",
            product.Name || "",
        ]);

        const csvContent = [
            headers,
            ...rows,
        ]
            .map((row) =>
                row
                    .map((value) => `"${String(value).replace(/"/g, '""')}"`)
                    .join(";")
            )
            .join("\n");

        // BOM dla poprawnego wyświetlania polskich znaków w Excelu
        const blob = new Blob(
            ["\uFEFF" + csvContent],
            { type: "text/csv;charset=utf-8;" }
        );

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        // Nazwa firmy jako nazwa pliku
        const fileName = (user.shop_name || "indeksy")
            .replace(/[<>:"/\\|?*]/g, "")
            .trim();

        link.download = `${fileName}.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    };

    if (!user) {
        return (
            <div className="text-xs text-gray-400 py-6 text-center">
                Brak danych odnośnie indeksów użytkownika.
                Użytkownik nie posiada przypisanych indeksów.
            </div>
        );
    }

    return (
        <div className="flex flex-col">

            {/* UŻYTKOWNIK */}
            <div
                className="
                    flex
                    items-center
                    justify-between
                    px-3
                    py-2.5
                    bg-gray-50
                    border
                    border-gray-200
                    rounded-lg
                    mb-2
                "
            >
                <div className="flex items-center gap-2 min-w-0">

                    <div
                        className="
                            flex
                            items-center
                            justify-center
                            w-8
                            h-8
                            rounded-full
                            bg-gray-200
                            text-gray-600
                            shrink-0
                        "
                    >
                        <FiUser size={15} />
                    </div>

                    <div className="flex flex-col min-w-0">
                        <span className="text-xs font-semibold text-gray-900 truncate">
                            {user.shop_name}
                        </span>

                        <span className="text-[11px] text-gray-500 truncate">
                            {user.client_email}
                        </span>
                    </div>
                </div>

                <div className="flex items-center gap-2 shrink-0">

                    {/* LICZBA INDEKSÓW */}
                    <span className="text-[11px] text-gray-400">
                        {users.length}{" "}
                        {users.length === 1 ? "indeks" : "indeksy"}
                    </span>

                    {/* EKSPORT CSV */}
                    <button
                        type="button"
                        onClick={exportToCSV}
                        title="Eksportuj indeksy do CSV"
                        className="
                            inline-flex
                            items-center
                            justify-center
                            w-7
                            h-7
                            rounded
                            border
                            border-gray-200
                            bg-white
                            text-gray-500
                            hover:bg-gray-100
                            hover:text-gray-700
                            transition-colors
                        "
                    >
                        <FiDownload size={14} />
                    </button>

                </div>
            </div>

            {/* WYSZUKIWARKA */}
            <Input
                label="Szukaj indeksu lub produktu"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                size="small"
                className="w-full mb-2 text-xs"
                fullWidth
                placeholder="Wprowadź indeks lub nazwę..."
            />

            {/* LISTA INDEKSÓW */}
            {filteredProducts.length === 0 ? (
                <p className="text-sm text-gray-500 py-4 text-center">
                    Brak wyników
                </p>
            ) : (
                <div className="max-h-[300px] overflow-y-auto space-y-1">

                    {filteredProducts.map((product, index) => (
                        <div
                            key={`${product.pn}-${index}`}
                            className="
                                flex
                                items-center
                                gap-3
                                px-3
                                py-2
                                bg-white
                                border
                                border-gray-200
                                rounded-lg
                                hover:bg-gray-50
                                hover:border-gray-300
                                transition-colors
                            "
                        >
                            <div
                                className="
                                    flex
                                    items-center
                                    justify-center
                                    w-7
                                    h-7
                                    rounded
                                    bg-red-50
                                    text-red-600
                                    shrink-0
                                "
                            >
                                <FiPackage size={14} />
                            </div>

                            <div className="flex flex-col min-w-0">
                                <span className="text-xs font-semibold text-gray-900">
                                    {product.pn}
                                </span>

                                <span className="text-[11px] text-gray-500 truncate">
                                    {product.Name}
                                </span>
                            </div>
                        </div>
                    ))}

                </div>
            )}
        </div>
    );
}

export default CompetitionUserIndexList;